import styled from "styled-components";

export const FixtureWarningWrapper = styled.div`
  position: relative;

  button {
    background: none;
    border: 0;
    width: 16px;
    height: 16px;
    padding: 0;
    margin-left: 8px;
  }
`;
